/* M22 color swatches on product cards (see snippets/m22b-swatches.liquid).
   Used on collection pages, New Arrivals / Best Sellers, search and the homepage / cart product rails.
   Every dot is a solid circle of the real fabric color, read from that color's studio flat-lay:
   1) find the garment's colors (the transparent / studio background is ignored)
   2) pick the color that matches the color NAME (e.g. Navy, Green, Berry); if the name gives no clue, the most dominant color.
      Two-tone names ("Natural/Green", "Natural/Blue"): the shared base (Natural) is skipped and the dot goes to the
      BIGGEST solid block of the named color family, e.g. a cap's bill, not the small letters.
      If the photo shows several products (e.g. a green and a blue cap together), only blocks in the named
      color family (blue for "Blue") are considered.
   3) average every pixel of that color in the photo and fill the dot with it (no photo texture, so no seams,
      logos, shadows or neighboring colors show inside the dot) */
(function(){
  if(window.__m22sw) return; window.__m22sw=true;
  var HINTS=[
    [/black|onyx|jet|ink/, [30,30,32], 1],
    [/white|cream|ivory|natural|bone/, [236,232,222], 1],
    [/heather grey|heather gray|grey|gray|ash|silver|charcoal|smoke|slate|stone|shadow/, [110,110,112], 1],
    [/sky|baby blue|powder/, [170,200,230], 0],
    [/navy|midnight/, [34,44,78], 0],
    [/blue|denim|indigo|lake|ocean|sky|cobalt|royal/, [50,75,140], 0],
    [/teal|aqua|turquoise|seafoam/, [40,140,140], 0],
    [/green|olive|forest|moss|sage|pine|hunter|army|evergreen/, [60,100,60], 0],
    [/red|berry|cherry|maroon|burgundy|wine|brick|crimson|cardinal/, [140,40,45], 0],
    [/pink|rose|blush|coral|salmon/, [225,140,150], 0],
    [/orange|rust|pumpkin|sunset/, [215,110,45], 0],
    [/yellow|gold|mustard|sun|butter/, [225,185,60], 0],
    [/tan|khaki|sand|beige|camel|oat|latte|dune/, [196,170,130], 1],
    [/brown|chocolate|coffee|walnut|mocha|tobacco/, [100,70,50], 0],
    [/purple|plum|lavender|violet|grape/, [110,70,130], 0]
  ];
  function hintOne(part){ var n=(part||'').toLowerCase(); for(var i=0;i<HINTS.length;i++){ if(HINTS[i][0].test(n)) return {c:HINTS[i][1],neutral:HINTS[i][2]}; } return null; }
  function hintFor(name){
    var parts=(name||'').split(/\s*(?:\/|\+|&|,|\band\b|\bwith\b|\bw\/)\s*/i).filter(Boolean);
    var found=[]; parts.forEach(function(p){ var h=hintOne(p); if(h) found.push(h); });
    if(!found.length){ var h0=hintOne(name); return h0?{c:h0.c,accent:false}:null; }
    var colorful=found.filter(function(h){return !h.neutral;}), neutral=found.filter(function(h){return h.neutral;});
    if(found.length>1 && colorful.length) return {c:colorful[colorful.length-1].c,accent:true,base:neutral.length?neutral[0].c:null};
    return {c:found[0].c,accent:false};
  }
  function d2(a,b){ var r=a[0]-b[0],g=a[1]-b[1],c=a[2]-b[2]; return r*r+g*g+c*c; }
  function chroma(c){ return Math.max(c[0],c[1],c[2])-Math.min(c[0],c[1],c[2]); }
  function hue(c){ var r=c[0]/255,g=c[1]/255,b=c[2]/255,mx=Math.max(r,g,b),mn=Math.min(r,g,b),dd=mx-mn; if(!dd) return -1; var h; if(mx===r) h=((g-b)/dd)%6; else if(mx===g) h=(b-r)/dd+2; else h=(r-g)/dd+4; h*=60; return h<0?h+360:h; }
  function hueGap(a,b){ var g=Math.abs(a-b)%360; return g>180?360-g:g; }
  function rgb(c){ return 'rgb('+Math.round(c[0])+','+Math.round(c[1])+','+Math.round(c[2])+')'; }
  /* color(src, name, cb): reads the dot color for a color name from its product photo and calls cb('rgb(...)').
     No usable photo: the color guessed from the name, or no call at all (the dot keeps its default).
     Shared with the product page (snippets/m22b-product-js) as window.m22SwatchColor. */
  function color(src,name,cb){
    function fallback(){ var h=hintFor(name); if(h) cb(rgb(h.c)); }
    if(!src){ fallback(); return; }
    var img=new Image(); img.crossOrigin='anonymous';
    img.onload=function(){
      try{
        var S=96, c=document.createElement('canvas'); c.width=S; c.height=S;
        var x=c.getContext('2d'); x.drawImage(img,0,0,S,S);
        var d=x.getImageData(0,0,S,S).data;
        var cs=[0,(S-1)*4,(S*(S-1))*4,(S*S-1)*4], bgc=[0,0,0], ba=0;
        cs.forEach(function(i){bgc[0]+=d[i];bgc[1]+=d[i+1];bgc[2]+=d[i+2];ba+=d[i+3];});
        bgc=bgc.map(function(v){return v/4;}); ba/=4;
        var N=S*S, keep=new Uint8Array(N), buckets={}, total=0;
        for(var p=0;p<N;p++){
          var i=p*4, px=[d[i],d[i+1],d[i+2]];
          if(d[i+3]<200) continue;
          if(ba>200 && d2(px,bgc)<1600) continue;
          keep[p]=1; total++;
          var k=(px[0]>>5)+'-'+(px[1]>>5)+'-'+(px[2]>>5);
          var o=buckets[k]||(buckets[k]={n:0,r:0,g:0,b:0}); o.n++;o.r+=px[0];o.g+=px[1];o.b+=px[2];
        }
        if(total<60){ fallback(); return; }
        var hint=hintFor(name);
        var cands=[]; for(var k2 in buckets){ var b=buckets[k2]; if(b.n/total>=0.01) cands.push({n:b.n,c:[b.r/b.n,b.g/b.n,b.b/b.n]}); }
        cands.sort(function(a,b){return b.n-a.n;});
        if(!cands.length){ fallback(); return; }
        var target=cands[0].c;
        if(hint && hint.accent){
          var base=hint.base||[236,232,222], hh=hue(hint.c);
          var pool=cands.filter(function(cd){ return d2(cd.c,base)>=3600 && !(chroma(cd.c)<18 && cd.c[0]>150); });
          var fam=pool.filter(function(cd){ var h=hue(cd.c); return chroma(cd.c)>=10 && h>=0 && hueGap(h,hh)<=45; });
          if(fam.length) pool=fam;
          var bestS=-1;
          pool.forEach(function(cd){ var s=cd.n/(1+d2(cd.c,hint.c)/12000); if(s>bestS){ bestS=s; target=cd.c; } });
        } else if(hint){
          var best=Infinity; cands.filter(function(cd){return cd.n/total>=0.06;}).slice(0,5).forEach(function(cd){ var s=d2(cd.c,hint.c)/Math.sqrt(cd.n); if(s<best){best=s;target=cd.c;} });
        }
        /* average of every pixel close to that color = the dot's fill */
        var sr=0, sg=0, sb=0, mcount=0;
        for(var q=0;q<N;q++){ if(keep[q]){ var j=q*4; if(d2([d[j],d[j+1],d[j+2]],target)<2400){ sr+=d[j]; sg+=d[j+1]; sb+=d[j+2]; mcount++; } } }
        cb(rgb(mcount ? [sr/mcount,sg/mcount,sb/mcount] : target));
      }catch(e){ fallback(); }
    };
    img.onerror=fallback;
    img.src=src;
  }
  window.m22SwatchColor=color;
  function paint(btn){ color(btn.getAttribute('data-src'),btn.getAttribute('aria-label'),function(col){ btn.style.backgroundImage='none'; btn.style.backgroundColor=col; }); }
  function init(root){ (root||document).querySelectorAll('.msw-d:not([data-done])').forEach(function(b){ b.setAttribute('data-done','1'); paint(b); }); }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.msw-d'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var wrap=b.closest('[data-msw]'); wrap.querySelectorAll('.msw-d').forEach(function(x){x.classList.toggle('is-on',x===b);});
    var full=b.getAttribute('data-img'); if(!full) return;
    var card=b.closest('[data-mqa-card]')||b.closest('.mc-card,.ms-card,.bb-card,.mr-card'); if(!card) return;
    var media=card.querySelector('.mc-media,.ms-media,.bb-card-media,.mr-media'); if(!media) return;
    var t=media.querySelector('img.mc-prod,img.ms-prod,img.bb-flat,img.mr-main')||media.querySelector('img'); if(!t) return;
    t.removeAttribute('srcset'); t.removeAttribute('sizes'); t.src=full;
    t.classList.add('is-flat');
    media.classList.add('msw-picked');
  },true);
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){init();}); } else { init(); }
  window.m22Swatches=init;
})();
